import { render } from "./ClienteSolicitacoesView.vue?vue&type=template&id=1edf006f"
import script from "./ClienteSolicitacoesView.vue?vue&type=script&lang=js"
export * from "./ClienteSolicitacoesView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__